var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcondelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3C5.9055 3 3 5.9055 3 9.5C3 13.0945 5.9055 16 9.5 16C13.0945 16 16 13.0945 16 9.5C16 5.9055 13.0945 3 9.5 3ZM12.75 11.8335L11.8335 12.75L9.5 10.4165L7.1665 12.75L6.25 11.8335L8.5835 9.5L6.25 7.1665L7.1665 6.25L9.5 8.5835L11.8335 6.25L12.75 7.1665L10.4165 9.5L12.75 11.8335Z",
    fill: "#EC5C52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcondelete);
export default __webpack_public_path__ + "static/media/icondelete.4d029e898ec23407f3c74b25a778ab6f.svg";
export { ForwardRef as ReactComponent };